import TokenService from "../autentication/token.service";

const getPermissionsOfCurrentUser = async () => {
  let user: any = TokenService.getUser();
  if (user !== null) {
    if (user.accessLevelNew === "Global Admin") {
      return {
        ViewSiteUpload: true,
        EditSiteUpload: true,
        ViewSiteSurvey: true,
        EditSiteSurvey: true,
        ViewSuveyDetails: true,
        EditSuveyDetails: true,
        ViewAllSurveyDashboard: true,
        GlobalAdmin: true,
        ReadOnlyGlobalAdmin: false,
        CustomerAdmin:false
      };
    } else if (
      (user.accessLevelNew === "" || user.type === "GlobalAdmin") &&
      user.readOnly
    ) {
      // Read only Global Admin
      return {
        ViewSiteUpload: true,
        EditSiteUpload: false,
        ViewSiteSurvey: true,
        EditSiteSurvey: false,
        ViewSuveyDetails: true,
        EditSuveyDetails: false,
        ViewAllSurveyDashboard: true,
        GlobalAdmin: false,
        ReadOnlyGlobalAdmin: true,
        CustomerAdmin:false
      };
    } else if (user.accessLevelNew === "Administrator") {
      if(user.type === "CustomerAdmin"){
        return {
          ViewSiteUpload: true,
          EditSiteUpload: false,
          ViewSiteSurvey: true,
          EditSiteSurvey: false,
          ViewSuveyDetails: true,
          EditSuveyDetails: false,
          ViewAllSurveyDashboard: true,
          GlobalAdmin: false,
          ReadOnlyGlobalAdmin: false,
          CustomerAdmin:true
        };
      }else{
        return {
          ViewSiteUpload: true,
          EditSiteUpload: false,
          ViewSiteSurvey: true,
          EditSiteSurvey: false,
          ViewSuveyDetails: true,
          EditSuveyDetails: false,
          ViewAllSurveyDashboard: true,
          GlobalAdmin: false,
          ReadOnlyGlobalAdmin: false,
          CustomerAdmin:false
        };
      }
      
    } else if (user.accessLevelNew === "Corporate") {
      return {
        ViewSiteUpload: true,
        EditSiteUpload: false,
        ViewSiteSurvey: true,
        EditSiteSurvey: false,
        ViewSuveyDetails: true,
        EditSuveyDetails: false,
        ViewAllSurveyDashboard: true,
        GlobalAdmin: false,
        ReadOnlyGlobalAdmin: false,
        CustomerAdmin:false
      };
    } else if (user.accessLevelNew === "Analyst") {
      return {
        ViewSiteUpload: true,
        EditSiteUpload: false,
        ViewSiteSurvey: true,
        EditSiteSurvey: false,
        ViewSuveyDetails: true,
        EditSuveyDetails: false,
        ViewAllSurveyDashboard: true,
        GlobalAdmin: false,
        ReadOnlyGlobalAdmin: false,
        CustomerAdmin:false
      };
    } else {
      return {
        ViewSiteUpload: true,
        EditSiteUpload: false,
        ViewSiteSurvey: true,
        EditSiteSurvey: false,
        ViewSuveyDetails: true,
        EditSuveyDetails: false,
        ViewAllSurveyDashboard: true,
        GlobalAdmin: false,
        ReadOnlyGlobalAdmin: false,
        CustomerAdmin:false
      };
    }
  } else {
    return {
      ViewSiteUpload: true,
      EditSiteUpload: false,
      ViewSiteSurvey: true,
      EditSiteSurvey: false,
      ViewSuveyDetails: true,
      EditSuveyDetails: false,
      ViewAllSurveyDashboard: true,
      GlobalAdmin: false,
      ReadOnlyGlobalAdmin: false,
      CustomerAdmin:false
    };
  }

  // return await api
  //     .get(ApiConstant.getPermissionsOfCurrentUser)
  //     .then(function (response: any) {
  //         return response.data;
  //     })
  //     .catch(function (error) {
  //         Helpers.ConsoleLogError(error);
  //     });
};

const SecurityService = {
  getPermissionsOfCurrentUser
};

export default SecurityService;